import { hashGameState } from "./hash.js";
import { FIXED_TICK_MS, } from "./types.js";
function invalid(message) {
    return { ok: false, error: { type: "ERROR", code: "INVALID_MESSAGE", message } };
}
function isRecord(value) {
    return typeof value === "object" && value !== null && !Array.isArray(value);
}
function finiteNumber(value) {
    return typeof value === "number" && Number.isFinite(value);
}
export function parseClientMessage(value) {
    if (!isRecord(value) || typeof value.type !== "string")
        return invalid("Message must be an object with a type");
    switch (value.type) {
        case "READY":
            if (value.ready !== undefined && typeof value.ready !== "boolean") {
                return invalid("READY.ready must be a boolean");
            }
            return value.ready === undefined
                ? { ok: true, value: { type: "READY" } }
                : { ok: true, value: { type: "READY", ready: value.ready } };
        case "INPUT":
            if (!Number.isSafeInteger(value.sequence) ||
                value.sequence < 0 ||
                !finiteNumber(value.clientTime) ||
                !finiteNumber(value.targetX) ||
                !finiteNumber(value.targetY) ||
                value.targetX < 0 ||
                value.targetX > 1 ||
                value.targetY < 0 ||
                value.targetY > 1) {
                return invalid("INPUT requires a non-negative sequence and finite normalized coordinates");
            }
            return {
                ok: true,
                value: {
                    type: "INPUT",
                    sequence: value.sequence,
                    clientTime: value.clientTime,
                    targetX: value.targetX,
                    targetY: value.targetY,
                },
            };
        case "PING":
            return finiteNumber(value.clientTime)
                ? { ok: true, value: { type: "PING", clientTime: value.clientTime } }
                : invalid("PING.clientTime must be finite");
        case "FORFEIT":
            return { ok: true, value: { type: "FORFEIT" } };
        default:
            return invalid(`Unsupported message type: ${value.type}`);
    }
}
export function createSnapshotMessage(state, options = {}) {
    const serverTime = options.serverTime ?? state.tick * FIXED_TICK_MS;
    const ackSequence = options.ackSequence ?? Math.max(state.players.PLAYER_A.lastProcessedSequence, state.players.PLAYER_B.lastProcessedSequence);
    return {
        type: "SNAPSHOT",
        matchId: state.matchId,
        tick: state.tick,
        serverTime,
        ackSequence,
        phase: state.phase,
        phaseTicksRemaining: state.phaseTicksRemaining,
        puck: {
            x: state.puck.position.x,
            y: state.puck.position.y,
            vx: state.puck.velocity.x,
            vy: state.puck.velocity.y,
        },
        playerA: {
            x: state.mallets.PLAYER_A.position.x,
            y: state.mallets.PLAYER_A.position.y,
            vx: state.mallets.PLAYER_A.velocity.x,
            vy: state.mallets.PLAYER_A.velocity.y,
        },
        playerB: {
            x: state.mallets.PLAYER_B.position.x,
            y: state.mallets.PLAYER_B.position.y,
            vx: state.mallets.PLAYER_B.velocity.x,
            vy: state.mallets.PLAYER_B.velocity.y,
        },
        scoreA: state.score.PLAYER_A,
        scoreB: state.score.PLAYER_B,
        remainingTimeMs: state.remainingTicks === null ? null : state.remainingTicks * FIXED_TICK_MS,
        stateHash: hashGameState(state),
    };
}
//# sourceMappingURL=protocol.js.map